export default "__VITE_ASSET__730129f5__"